module.exports = __webpack_public_path__ + "static/media/groups-remove-default.9f1a5053.svg";